import { takeEvery } from "redux-saga/effects";
import { downloadPDFByUrlSaga, downloadPDFSaga, printPDFSaga } from "./pdf";
import { downloadPDF, downloadPDFByUrl, printPDF } from "~/api/choreography";

export function* pdfApiSaga() {
    yield takeEvery(downloadPDF.toString(), downloadPDFSaga);
    yield takeEvery(downloadPDFByUrl.toString(), downloadPDFByUrlSaga);
    yield takeEvery(printPDF.toString(), printPDFSaga);
}
